import { styled } from '@withjoy/joykit';

export const Container = styled.div`
  --mobile-public-shop-navbar-height: 70px;
`;
